import { Fragment, useContext, useEffect, useState } from "react";
import { DARK_GREEN, GREY_BUTTON, YELLOW } from "../../color";
import TriviaInput from "../../components/inputfield/triviainput/triviainput";
import { getMessageBox } from "../../components/navbar/navbar";
import Button from "../../components/Trivia/Button/Button";
import MessageSlot from "../../components/Trivia/MessageSlot/MessageSlot";
import { ADMIN_GAME_CODE, GAME_CODE, SERVER_STATUS } from "../../constants";
import { useAuthContext } from "../../context/Auth/AuthContainer";
import { PopupContext } from "../../context/Popup/PopupContext";
import LocalStorage from "../../services/LocalStorage";
import NetworkManager from "../../services/NetworkManager";
import { EMessageType } from "../Enums/Enums";
import classes from "./TriviaMakerPopup.module.scss";
import InputIcon from "../../assets/icons/questionmark.svg";
import { CircularSpinner } from "../../components/Spinner/Spinner";
import { useHistory } from "react-router-dom";
import { MANAGE_PLAYER_COLLECTION } from "../routes/RoutesConstants";

const TriviaMakerPopup = () => {
  const authContext = useAuthContext();
  const { showPopup } = useContext(PopupContext);
  const [isLoading, showLoader] = useState<boolean>(false);
  const [serverStatus, setServerStatus] = useState({
    gameCode: "",
    value: "", //invalid QUIZMASTER code
  });
  const history = useHistory();

  useEffect(() => {
    if (authContext.checkAdminAuthentication()) {
      showPopup(null);
      history.push(MANAGE_PLAYER_COLLECTION);
      return;
    }
    return () => {
      showPopup(null);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleClick = async () => {
    try {
      // setIsLoading(true);
      const gameCode = LocalStorage.GetItem(GAME_CODE) || "";
      if (!gameCode) {
        // setIsLoading(false);
        return setServerStatus({
          ...serverStatus,
          value: SERVER_STATUS.GAME_CODE_NOT_FOUND.value,
        });
      }
      setServerStatus({
        ...serverStatus,
        value: "",
      });
      showLoader(true);
      const response = await NetworkManager.AdminLogin(
        gameCode,
        serverStatus.gameCode
      );
      const { token } = response.body;
      authContext.authenticateAdmin(token);
      LocalStorage.SetItem(ADMIN_GAME_CODE, serverStatus.gameCode);
      // setIsLoading(false);
      // showPopup(null);
      history.push(MANAGE_PLAYER_COLLECTION);
    } catch (err) {
      setServerStatus({
        ...serverStatus,
        value: SERVER_STATUS.INVALID_ADMIN_GAME_CODE.value,
      });
      // setIsLoading(false);
    }
    showLoader(false);
  };
  const onKeyDownEvent = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleClick();
    }
  };
  return (
    <Fragment>
      {getMessageBox(
        EMessageType.Info,
        "TRIVIA MAKER",
        <div>
          <span style={{ fontFamily: "SegoeUI", fontSize: "1.75em" }}>
            Enter your Quizmaster code to access Trivia Maker
          </span>
          <div style={{ display: "flex", alignItems: "center" }}>
            <TriviaInput
              containerStyles={{ fontFamily: "Bebas Neue", width: "50%" }}
              autoFocus
              id="code"
              name="code"
              icon={InputIcon}
              onValueChanged={(e) => {
                setServerStatus({
                  ...serverStatus,
                  gameCode: e.target.value,
                });
              }}
              onKeyDown={onKeyDownEvent}
              maxLength={4}
              pattern={"[0-9]"}
            >
              Your Quizmaster code is 4 digits and found in your confirmation
              email.
            </TriviaInput>
            {!serverStatus.value ? null : (
              <div className={classes["error"]}>
                <MessageSlot
                  color={"#FC5C65"}
                  className={classes["errorMessage"]}
                >
                  {serverStatus.value}
                </MessageSlot>
              </div>
            )}
          </div>
        </div>,

        <Button
          leftArrow={false}
          style={{
            fontSize: "2.25em",
            paddingLeft: "5px",
            justifyContent: "center",
          }}
          width={200}
          height={50}
          onClick={() => {
            handleClick();
          }}
          color={serverStatus.gameCode.length !== 4 ? GREY_BUTTON : DARK_GREEN}
          disabled={serverStatus.gameCode.length !== 4}
        >
          {"CONFIRM"}
        </Button>,
        <Button
          color={YELLOW}
          style={{
            fontSize: "2.25em",
            paddingLeft: "5px",
            justifyContent: "center",
          }}
          width={200}
          height={50}
          onClick={() => {
            showPopup(null);
          }}
        >
          {"CANCEL"}
        </Button>
      )}
      {isLoading ? <CircularSpinner></CircularSpinner> : null}
    </Fragment>
  );
};

export default TriviaMakerPopup;
